import { Box, Button, Flex, Text } from '@chakra-ui/react'
import { AlertTriangle, RefreshCw, WifiOff } from 'lucide-react'

const DEFAULT_TITLE = 'Something went wrong'

const DENSITY = {
  compact: { paddingBlock: '6' },
  default: { paddingBlock: '10' },
}

/**
 * Failure state for a data region. Uses the error tone on the icon only — the
 * surrounding surface stays neutral so a failed panel does not turn into a red
 * block.
 */
export const ErrorState = ({
  error,
  title,
  description,
  onRetry,
  retryLabel = 'Try again',
  density = 'default',
}) => {
  const isNetwork = Boolean(error?.isNetworkError)
  const Icon = isNetwork ? WifiOff : AlertTriangle

  return (
    <Flex
      direction="column"
      align="center"
      textAlign="center"
      gap="3"
      paddingInline="6"
      role="alert"
      {...DENSITY[density]}
    >
      <Flex
        align="center"
        justify="center"
        boxSize="9"
        borderRadius="md"
        bg="status.errorSubtle"
        borderWidth="1px"
        borderColor="status.errorBorder"
        color="status.errorFg"
        aria-hidden="true"
      >
        <Icon size={18} />
      </Flex>

      <Box>
        <Text textStyle="label">{title ?? (isNetwork ? 'Connection lost' : DEFAULT_TITLE)}</Text>
        <Text textStyle="helperText" marginTop="1" maxWidth="24rem">
          {description ?? error?.message ?? 'Please try again.'}
        </Text>
      </Box>

      {onRetry && (
        <Button size="sm" variant="secondary" onClick={onRetry} marginTop="1">
          <RefreshCw aria-hidden="true" />
          {retryLabel}
        </Button>
      )}
    </Flex>
  )
}
